// extracted by mini-css-extract-plugin
export var core = "Ebook-module--core--482f6";
export var cta = "Ebook-module--cta--d1b35";
export var title = "Ebook-module--title--4430e";